export default "__VITE_ASSET__BdPDHCLh__"